module.exports = __webpack_public_path__ + "front/img/edm-bj.ccfca808.png";